
import { Routes } from '@angular/router';

import { AppShell } from './core/layout/app-shell/app-shell';
import { Dashboard } from './features/dashboard/dashboard';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppShell,
    children: [
      {
        path: '',
        component: Dashboard,
      },
      {
        path: 'fields',
        loadComponent: () =>
          import('./features/fields/fields').then(
            (module) => module.Fields,
          ),
      },
      {
        path: 'planning',
        loadComponent: () =>
          import('./features/planning/planning').then(
            (module) => module.Planning,
          ),
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('./features/calendar/calendar').then(
            (module) => module.CalendarComponent,
          ),
      },
    ],
  },
];
